export enum SpotifyEvent {
  PageView = 'view',
  Lead = 'lead',
  Purchase = 'purchase',
}
